export default __webpack_public_path__ + "static/dacs03-74551bbf9dd0ebbfd7dc9807fd247057.jpg";